/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class EmployeeAccountSettingsFormDirectiveController {

        public static $inject : string[] = [
            '$dealerwareEmployeeFactory',
            '$dealerwareLoading',
            '$scope',
            '$filter',
            '$dealerwareNotification',
            '$mdDialog',
            'CurrentUser',
            'DataUtils'
        ];

        public employee: any;
        public onSaveSuccess: any;
        public onSaveError: any;
        public onCancel: any;
        public accountSettingsForm: any;
        public dataUtils: any;

        constructor(public $dealerwareEmployeeFactory: any,
                    public $dealerwareLoading: any,
                    public $scope: any,
                    public $filter: any,
                    public $dealerwareNotification: any,
                    public $mdDialog: any,
                    public CurrentUser: any,
                    public DataUtils: any) {
            if (!this.employee) {
                this.employee = this.$dealerwareEmployeeFactory.getInstance();
            }

            this.dataUtils = DataUtils.getInstance();
        }

        // Force input text into (512) 555-1212 format.
        //
        public formatPhoneNumber ( formatArgs : any ) : any {
            return this.dataUtils.formatPhoneNumber(formatArgs);
        }

        public saveEmployee() : void {
            var _self = this;

            var loader = this.$dealerwareLoading.show('Saving...');
            this.employee.accountSettings.$update({
                promise: true,
                params: { location_id: this.employee.locationId }
            }).then(
                function() {
                    loader.close();
                    _self.$dealerwareNotification.toast('Account Settings Saved!');
                    _self.employee.accountSettings.markAsMaster();
                    _self.$scope.accountSettingsForm.$setPristine();
                },
                function(response : any) {
                    loader.close();
                    _self.$dealerwareNotification.apiError(response);
                }
            );
        }

        public activateEmployee() : void {
            var _self = this;

            var confirmationText = 'Are you sure you\'d like to activate this account?';

            var confirm = this.$mdDialog.confirm()
                .textContent(confirmationText)
                .ariaLabel(confirmationText)
                .ok('Activate')
                .cancel('Cancel');

            this.$mdDialog.show(confirm)
                .then(() => {

                    var loader = this.$dealerwareLoading.show('Activating Employee...');
                    this.employee.accountSettings.$activate({
                        promise: true,
                        params: { location_id: this.employee.locationId }
                    })
                        .then( ( response: any ) => {
                            this.employee.accountSettings.data.active = response.data.active;
                            if (this.CurrentUser.user.hasRole('user_role_manager')) {
                                this.employee.loadRoles();
                            }
                        })
                        .catch( ( response: any ) => {
                            _self.$dealerwareNotification.apiError(response);
                        })
                        .finally( ( ) => {
                            loader.close();
                        });
                });

        }

        public deactivateEmployee() : void {
            var _self = this;

            var confirmationText = 'Are you sure you\'d like to deactivate this account?';

            var confirm = this.$mdDialog.confirm()
                .textContent(confirmationText)
                .ariaLabel(confirmationText)
                .ok('Deactivate')
                .cancel('Cancel');

            this.$mdDialog.show(confirm)
                .then(() => {

                    var loader = this.$dealerwareLoading.show('Deactivating Employee...');
                    this.employee.accountSettings.$deactivate({
                        promise: true,
                        params: { location_id: this.employee.locationId }
                    })
                        .then( ( ) => {
                            this.employee.accountSettings.data.active = false;
                        })
                        .catch( ( response: any ) => {
                            _self.$dealerwareNotification.apiError(response);
                        })
                        .finally( ( ) => {
                            loader.close();
                        });
                });
        }

        public cancel() : void {

            if (this.onCancel && angular.isFunction(this.onCancel)) {
                this.onCancel();
            }
        }

        public manuallyConfirm() : void {
            var _self = this;

            var loader = this.$dealerwareLoading.show('Confirming Employee...');
            this.employee.accountSettings.$manuallyConfirm({
                promise: true,
                params: { location_id: this.employee.locationId }
            }).then(
                function(response: any) {
                    _self.employee.accountSettings.data.confirmed = response.data.confirmed;
                    _self.employee.accountSettings.data.confirmed_at = response.data.confirmed_at;
                    _self.employee.accountSettings.data.confirmed_at_display = response.data.confirmed_at_display;
                    _self.employee.accountSettings.data.manually_confirmed = response.data.manually_confirmed;
                    loader.close();
                },
                function(response: any) {
                    loader.close();
                    _self.$dealerwareNotification.apiError(response);
                }
            );
        }

        public clearActivationRequired() : void {
            var _self = this;

            var loader = this.$dealerwareLoading.show('Clearing Activation Required...');
            this.employee.accountSettings.$clearActivationRequired({
                promise: true,
                params: { location_id: this.employee.locationId }
            }).then(
                function(response: any) {
                    _self.employee.accountSettings.data.company_activation_required = response.data.company_activation_required;
                    loader.close();
                },
                function(response: any) {
                    loader.close();
                    _self.$dealerwareNotification.apiError(response);
                }
            );
        }
    }

    getDealerwareWebComponentsModule().controller('EmployeeAccountSettingsFormDirectiveController', EmployeeAccountSettingsFormDirectiveController);


    export class EmployeeAccountSettingsFormDirective implements ng.IDirective {

        public restrict         : string    =   'EA';
        public controller       : any       =   'EmployeeAccountSettingsFormDirectiveController';
        public controllerAs     : string    =   'accountSettingsController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            onSaveSuccess: '&',
            onSaveError: '&',
            onCancel: '&',
            employee: '='
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/employee/account_settings/account_settings_form_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {
        }

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {
        }


    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareEmployeeAccountSettingsForm",() => new EmployeeAccountSettingsFormDirective());

}
